// Import emoji mappings from shared configuration file
// This ensures PHP and JS emoji support stays synchronized
import emojiMapData from "../../../config/emojiMap.json";
import { logError } from "./logError";

// Emoji mappings loaded from config/emojiMap.json
// DO NOT modify this directly - update the JSON file instead
export const emojiMap = emojiMapData;

export function replaceEmojiShortcodes(text) {
	if (typeof text !== "string") return text;

	// Check if emoji map is empty and log error
	if (Object.keys(emojiMap).length === 0) {
		logError("Emoji map is empty - emojis will not be replaced");
		return text;
	}

	// Supports hyphens in emoji shortcodes
	const shortcodeRegex = /:\w[\w-]*:/g;

	return text.replace(shortcodeRegex, (match) => {
		if (emojiMap[match]) {
			return emojiMap[match];
		} else {
			logError(`Unknown emoji shortcode "${match}" in string: "${text}"`);

			return "";
		}
	});
}
